module.exports = __webpack_public_path__ + "img/tag-top-1x.b74b490.png";